// One definition of the four-quadrant status, shared by every territory view.
export const STATUS_KEYS = ["green", "yellow", "blue", "red"];

export const STATUS_META = {
  green: {
    label: "Visited + referring",
    short: "Active",
    advice: "Keep the rhythm — these relationships are paying back",
    dot: "#16a34a",
    chip: "bg-emerald-100 text-emerald-900 dark:bg-emerald-900/40 dark:text-emerald-200",
    accent: "border-l-emerald-500",
    bar: "bg-emerald-500",
    text: "text-emerald-600",
  },
  yellow: {
    label: "Referring, not visited",
    short: "At risk",
    advice: "Referring without a single visit — the most valuable call to make",
    dot: "#eab308",
    chip: "bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-200",
    accent: "border-l-amber-500",
    bar: "bg-amber-500",
    text: "text-amber-600",
  },
  blue: {
    label: "Visited, not referring",
    short: "Orphaned",
    advice: "Visits are going in but nothing is coming out — ask what is blocking them",
    dot: "#2563eb",
    chip: "bg-blue-100 text-blue-900 dark:bg-blue-900/40 dark:text-blue-200",
    accent: "border-l-blue-500",
    bar: "bg-blue-500",
    text: "text-blue-600",
  },
  red: {
    label: "Inactive",
    short: "Inactive",
    advice: "No visit and no referral in the window — lowest priority",
    dot: "#dc2626",
    chip: "bg-red-100 text-red-900 dark:bg-red-900/40 dark:text-red-200",
    accent: "border-l-red-500",
    bar: "bg-red-500",
    text: "text-red-600",
  },
};

export const PRECISION_LABEL = {
  address: "Street address",
  suburb: "Suburb centre",
  subregion: "Sub-area centre",
  city: "City centre only",
};

export const PRECISION_CHIP = {
  address: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200",
  suburb: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200",
  subregion: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200",
  city: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200",
};
